/*
 * @Author: yejianfei
 * @Date: 2022-06-19 14:17:25
 * @LastEditors: yejianfei
 * @LastEditTime: 2023-04-04 20:48:40
 * @Description:
 * @Developer:
 */
import React, { useEffect, useState } from 'react';
import { App, message } from 'antd';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
export const RouterContext = React.createContext({
    message: () => { },
});
export default function (options) {
    return (PageComponent) => () => {
        const onBeforeEnter = (options === null || options === void 0 ? void 0 : options.onBeforeEnter) || (() => Promise.resolve(true));
        const [searchParams, _setSearchParams] = useSearchParams();
        const [props, setProps] = useState({});
        const [enter, setEnter] = useState(false);
        const [messageApi, contextHolder] = message.useMessage();
        const route = {
            navigate: useNavigate(),
            params: useParams(),
            searchParams: searchParams
        };
        const app = App.useApp();
        useEffect(() => {
            onBeforeEnter(route, app).then((value) => {
                if (value && typeof (value) === 'object' && !Array.isArray(value)) {
                    setProps(value);
                }
                setEnter(!(value === false));
            });
        }, []);
        return (React.createElement(React.Fragment, null,
            React.createElement(RouterContext.Provider, { value: {
                    message: (props) => messageApi.open(props)
                } },
                enter ? React.createElement(PageComponent, Object.assign({}, props, { route: route, app: app })) : React.createElement("div", null, "load..."),
                contextHolder)));
    };
}
